const GERMAN_DAY_ABBR = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

function getBerlinTime(): Date {
  const now = new Date();
  const berlinStr = now.toLocaleString('en-US', { timeZone: 'Europe/Berlin' });
  return new Date(berlinStr);
}

export function isOutsideBusinessHours(): boolean {
  const berlin = getBerlinTime();
  const day = berlin.getDay();
  const hour = berlin.getHours();

  if (day === 0 || day === 6) return true;
  if (hour < 8 || hour >= 17) return true;
  return false;
}

export function getNextBusinessDayLabel(): string {
  const berlin = getBerlinTime();
  const day = berlin.getDay();
  const hour = berlin.getHours();

  let daysToAdd = 0;

  if (day === 6) {
    daysToAdd = 2;
  } else if (day === 0) {
    daysToAdd = 1;
  } else if (day === 5 && hour >= 17) {
    daysToAdd = 3;
  } else if (hour >= 17) {
    daysToAdd = 1;
  } else if (hour < 8) {
    daysToAdd = 0;
  }

  const target = new Date(berlin);
  target.setDate(target.getDate() + daysToAdd);
  const targetDay = target.getDay();
  return `${GERMAN_DAY_ABBR[targetDay]} 9:00`;
}
